import { baseSplitApi } from "../baseApi";
import { newLoginTag } from "../userAuth";
import { updateRegularizationStatusTag } from "./regularization";

const clockInPath = '/attendance/clock_in'

const clockOutPath = '/attendance/clock_out'

const addAttendanceDataCollection = '/attendance/status'

const clockInClockOutDataPath = '/attendance/history'

const attendanceTableTag = 'ATTENDANCETABLE'


export const clockInOutApi = baseSplitApi.injectEndpoints({
    endpoints: (build) => ({
        clockIn: build.mutation({
            query: (clockInData) => {
                return {
                    url: clockInPath,
                    method: 'PUT',
                    body: clockInData
                }
            },
            invalidatesTags: [attendanceTableTag]
        }),
        clockOut: build.mutation({
            query: (clockOutData) => {
                return {
                    url: clockOutPath,
                    method: 'PUT',
                    body: clockOutData
                }
            },
            invalidatesTags: [attendanceTableTag]
        }),
        addDataAttendanceCollection: build.query({
            query: () => {
                return {
                    url: addAttendanceDataCollection,
                    method: 'GET'
                }
            },
            providesTags: [attendanceTableTag, newLoginTag]
        }),
        getAllClockInClockoutData: build.query({
            query: ({ startDate, endDate }) => {
                return {
                    url: `${clockInClockOutDataPath}?startDate=${startDate}&endDate=${endDate}`,
                    method: 'GET',
                }
            },
            providesTags: [attendanceTableTag, updateRegularizationStatusTag, newLoginTag]
        })
    }),
    overrideExisting: false,
})

export const { useClockInMutation, useAddDataAttendanceCollectionQuery, useClockOutMutation, useGetAllClockInClockoutDataQuery } = clockInOutApi